/* MaterioLab Supply — Pass 7 functional QC. No content or business logic changes. */
(function () {
  'use strict';

  function preserveCollectionFiltersWhenSorting() {
    document.querySelectorAll('.ml-collection .ml-sort').forEach(function (form) {
      var select = form.querySelector('select[name="sort_by"]');
      if (!select || select.dataset.mlSortQc === 'ready') return;

      select.dataset.mlSortQc = 'ready';
      /* Replace the inline native submit so active filter query parameters can be retained first. */
      select.onchange = null;
      select.addEventListener('change', function () {
        form.querySelectorAll('[data-ml-preserved-filter]').forEach(function (input) {
          input.remove();
        });

        var params = new URLSearchParams(window.location.search);
        params.forEach(function (value, key) {
          if (key.indexOf('filter.') !== 0) return;
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          input.setAttribute('data-ml-preserved-filter', '');
          form.appendChild(input);
        });

        form.submit();
      });
    });
  }

  function largeShopifyImageUrl(source) {
    try {
      var url = new URL(source, window.location.origin);
      if (url.searchParams.has('width')) url.searchParams.set('width', '1600');
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function enableProductImageThumbnails() {
    document.querySelectorAll('.ml-rfq-product').forEach(function (root) {
      var hero = root.querySelector('.ml-rfq-product__hero-image img');
      var thumbs = root.querySelectorAll('.ml-rfq-product__thumb');
      if (!hero || thumbs.length < 2) return;

      thumbs.forEach(function (thumb, index) {
        if (thumb.dataset.mlThumbQc === 'ready') return;
        thumb.dataset.mlThumbQc = 'ready';
        thumb.setAttribute('role', 'button');
        thumb.setAttribute('tabindex', '0');
        thumb.setAttribute('aria-label', 'View product image ' + (index + 1));
        thumb.setAttribute('aria-current', index === 0 ? 'true' : 'false');

        function activate() {
          var image = thumb.querySelector('img');
          if (!image) return;
          var source = image.currentSrc || image.src;
          hero.src = largeShopifyImageUrl(source);
          hero.removeAttribute('srcset');
          hero.removeAttribute('sizes');
          hero.alt = image.alt || '';

          thumbs.forEach(function (item) {
            var active = item === thumb;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-current', active ? 'true' : 'false');
          });
        }

        thumb.addEventListener('click', activate);
        thumb.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          activate();
        });
      });
    });
  }

  function init() {
    preserveCollectionFiltersWhenSorting();
    enableProductImageThumbnails();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
